export type Rgb = [number, number, number];

/** Source: https://stackoverflow.com/a/13532993/3989225 */
export function shadeColor(hexColor: string, positiveOrNegativePercent: number): string {
	let { r, g, b } = hexToRgb(hexColor);

	r = parseInt(String((r * (100 + positiveOrNegativePercent)) / 100));
	g = parseInt(String((g * (100 + positiveOrNegativePercent)) / 100));
	b = parseInt(String((b * (100 + positiveOrNegativePercent)) / 100));

	r = r < 255 ? r : 255;
	g = g < 255 ? g : 255;
	b = b < 255 ? b : 255;

	const rr = r.toString(16).length == 1 ? '0' + r.toString(16) : r.toString(16);
	const gg = g.toString(16).length == 1 ? '0' + g.toString(16) : g.toString(16);
	const bb = b.toString(16).length == 1 ? '0' + b.toString(16) : b.toString(16);
	return '#' + rr + gg + bb;
}

export function hexToRgb(hexColor: string) {
	const r = parseInt(hexColor.substring(1, 3), 16);
	const g = parseInt(hexColor.substring(3, 5), 16);
	const b = parseInt(hexColor.substring(5, 7), 16);
	return { r, b, g };
}

export function getColorForUserName(userName: string) {
	return stringToHslColor(userName, 30, 60);
}

export function stringToHslColor(string: string, saturation: number, lightness: number) {
	let hash = 0;
	for (let i = 0; i < string.length; i++) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}
	const h = hash % 360;
	return 'hsl(' + h + ', ' + saturation + '%, ' + lightness + '%)';
}

export function interpolateColor(hexColor1: string, hexColor2: string, ratio: number) {
	if (ratio <= 0) {
		return hexColor1;
	}
	if (ratio >= 1) {
		return hexColor2;
	}
	const { r: r1, g: g1, b: b1 } = hexToRgb(hexColor1);
	const { r: r2, g: g2, b: b2 } = hexToRgb(hexColor2);

	const r = Math.round(r1 + (r2 - r1) * ratio);
	const g = Math.round(g1 + (g2 - g1) * ratio);
	const b = Math.round(b1 + (b2 - b1) * ratio);

	return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).substring(0, 6);
}

export function getPerceivedBrightness(colorRgbOrHex: string) {
	// Variables for red, green, blue values
	let r: number;
	let g: number;
	let b: number;

	// Check the format of the color, HEX or RGB?
	if (colorRgbOrHex.match(/^rgb/)) {
		// If RGB --> store the red, green, blue values in separate variables
		const matcher = colorRgbOrHex.match(
			/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
		);

		r = parseInt(matcher![1]);
		g = parseInt(matcher![2]);
		b = parseInt(matcher![3]);
	} else {
		// If hex --> Convert it to RGB: http://gist.github.com/983661
		// @ts-ignore
		const rgb = +('0x' + colorRgbOrHex.slice(1).replace(colorRgbOrHex.length < 5 && /./g, '$&$&'));

		r = rgb >> 16;
		g = (rgb >> 8) & 255;
		b = rgb & 255;
	}

	// HSP equation from http://alienryderflex.com/hsp.html
	return Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
}

export function isDarkColor(colorRgbOrHex: string) {
	return getPerceivedBrightness(colorRgbOrHex) < 127.5;
}
